import { render, staticRenderFns } from "./homeWidgets.vue?vue&type=template&id=eef4836a&scoped=true"
import script from "./homeWidgets.vue?vue&type=script&lang=js"
export * from "./homeWidgets.vue?vue&type=script&lang=js"
import style0 from "./homeWidgets.vue?vue&type=style&index=0&id=eef4836a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef4836a",
  null
  
)

export default component.exports